export default __webpack_public_path__ + "static/media/31.3abce743.png";